import { OverlayTrigger, Tooltip } from "react-bootstrap";
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

const WarningTooltip = ({text, ...props}) =>{
    
    return(
        <OverlayTrigger overlay={<Tooltip>{text}</Tooltip>}>
            <ErrorOutlineIcon style={{fontSize:"1rem", marginLeft:"0.5em", color:"red"}} {...props}/>
        </OverlayTrigger>)
}

export default WarningTooltip;